(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-nav-acc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  var summary = event.target.closest && event.target.closest('.mm-acc > summary');
  if (!summary) return;
  var current = summary.parentNode;
  document.querySelectorAll('.mm-acc[open]').forEach(function (other) {
    if (other !== current) other.removeAttribute('open');
  });
});
  } catch(e) { console.error(e); }
})();

})();
